import { ReactNode } from 'react';
import { Product, ProductType } from '@v2/shared/lib/types';
import { isNamedFormat } from '@v2/shared/lib/utils';

interface Props {
  product: Product;
}

export default function Variant({ product }: Props) {
  const baseSku = product.base_sku;

  if (!baseSku) {
    return null;
  }

  if (product.product_type === ProductType.TYPE_MAGAZINE) {
    if (baseSku.attributes && baseSku.attributes.issues) {
      return (
        <Term>
          {baseSku.attributes.issues} Issue{(baseSku.attributes.issues as number) > 1 ? `s` : ''}
        </Term>
      );
    }
  }

  const term = baseSku.variants.filter((v) => v.type_id === 1)[0];

  if (!term) {
    return null;
  }

  const authors = product.genome_attributes && (product.genome_attributes as { authors?: string[] }).authors;
  const format = isNamedFormat(term.content) ? term.content : null;

  if (product.product_type === ProductType.TYPE_BOOK && authors) {
    return (
      <>
        <Author>{authors[0]}</Author>
        {format && <Term>{format}</Term>}
      </>
    );
  }

  return format ? <Term>{format}</Term> : null;
}

function Author({ children }: { children: ReactNode }) {
  return <div className="font-semibold text-xs text-slate-500 italic">{children}</div>;
}

function Term({ children }: { children: ReactNode }) {
  return <div className="font-semibold text-xs text-slate-700">{children}</div>;
}
